import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { SegmentedStepper } from '@dev-go4ellis/go4-design-system';
import { trackMixpanelPageView } from 'helpers/post';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import { update as updateUser } from 'redux/ducks/User';
import { changeProfileField } from 'redux/ducks/Post/Profile';
import AdvancedOptionCard from '../OptionCards/AdvancedOptionCard';
import { getFunnelStepperConfig } from '../funnelSteps';
import './Persona.scss';

// Step six of the updated Job Poster funnel (GO4-1729). The progress stepper is rendered
// centered in the top navigation — see scenes/V3/CreateAccountScene/funnelSteps.
//
// One-Time / Recurring → pre-set eventType='per-diem' and skip the V2 EventType question
// (which is essentially the same question) by going straight to /v2/create-event/setting.
// Long-Term Placement → route to the in-app consultation form (same destination as the
// "Schedule a Consultation" button in step five — see scenes/V3/CreateAccountScene/NextSteps).

const REQUEST_CONSULTATION_PATH = '/create-account/request-consultation';

const CREATE_JOB_SETTING_PATH = '/v2/create-event/setting';

const PERSONA_OPTIONS = [
  {
    title: 'One-Time / Per Diem',
    body: 'A single event, game, or shift — post it and get applicants fast.',
    value: 'Single',
  },
  {
    title: 'Recurring',
    body: 'Weekly or monthly coverage on a set schedule.',
    value: 'Recurring',
  },
  {
    title: 'Long-Term Placement',
    body: 'Seasonal, school-year, or full-time — our team will help match you.',
    value: 'Contract',
  },
];

class Persona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPersona: null,
    };
  }

  componentDidMount() {
    trackMixpanelPageView('/create-account/persona');
  }

  onSelect = value => () => {
    this.setState({ selectedPersona: value });
    trackMixpanelPageView('/persona_selected', {
      persona: value,
      page: '/create-account/persona',
    });
  };

  onContinue = () => {
    const { selectedPersona } = this.state;
    if (!selectedPersona) return;

    this.props.updateUser({
      ...this.props.user,
      userPersona: selectedPersona,
    });

    if (selectedPersona === 'Contract') {
      trackMixpanelPageView('LongTermForm');
      this.props.setEventType('contract');
      this.props.history.push(REQUEST_CONSULTATION_PATH);
      return;
    }

    this.props.setEventType('per-diem');
    this.props.history.push(CREATE_JOB_SETTING_PATH);
  };

  render() {
    const { selectedPersona } = this.state;
    const buttonDisabled = !selectedPersona;
    const funnelStepper = getFunnelStepperConfig('/create-account/persona');

    return (
      <div className="persona">
        <main>
          {funnelStepper && (
            <div className="next-steps-mobile-stepper">
              <SegmentedStepper total={funnelStepper.total} current={funnelStepper.current} size="sm" />
            </div>
          )}
          <header>
            <div className="screen-title gotham-bold-font">Great, let's find you an athletic trainer!</div>
            <div className="screen-subtitle">How do you plan to use Go4?</div>
          </header>
          <div className="content">
            <div className="persona-options">
              {PERSONA_OPTIONS.map(({ title, body, value }) => (
                <AdvancedOptionCard
                  key={value}
                  className="persona-option"
                  title={title}
                  body={body}
                  onClick={this.onSelect(value)}
                  selected={selectedPersona === value}
                  inlineArrowOnSelect
                />
              ))}
            </div>
          </div>
        </main>
        <div className="navigation-buttons">
          <Button onClick={this.onContinue} className="continue-button" disabled={buttonDisabled}>
            <div>Continue &#8594;</div>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.session.authenticated,
  user: state.session.currentUser || state.registration.user,
});

const mapDispatchToProps = dispatch => ({
  updateUser: user => dispatch(updateUser(user)),
  setEventType: value => dispatch(changeProfileField({ name: 'eventType', value })),
});

export default withQueryParamCapture(connect(mapStateToProps, mapDispatchToProps)(Persona));
